import Square from "./Square";

const Button = () => {
  return <></>;
};

Button.Square = Square;

export default Button;
